import React from 'react'
import RamtechLogoSvg from '../SvgComponents/RamtechLogoSvg'
import ici_logo from '../../assets/images/ici_logo.png'
import uaic_logo from '../../assets/svgs/uaic_logo.svg'

function LogoBar() {
  return (
    <div
        className='w-full
                  flex items-center justify-center
                  pt-2 pb-2'
    >
        <div
            className='w-[80%]
                      flex flex-col lg:flex-row lg:items-center
                      '
        >
            <div
                className='flex flex-col md:flex-row items-center mb-8 lg:mb-0'
            >
                <div
                    className='w-[72px] h-[72px]
                              flex items-center justify-center
                              mr-2'       
                >
                    <RamtechLogoSvg />
                </div>
                <div
                    className='text-center md:text-start'
                >
                    <p
                        className='text-2xl font-bold'
                    >
                        RAMTECH
                    </p>
                    <p
                        className='text-[#3490c9] font-medium text-lg'
                    >
                        Research Center on Advanced Materials & Technologies
                    </p>
                </div>
            </div>
            <div
                className='w-full flex flex-col md:flex-row items-center'
            >
                <a
                    href='https://ici.uaic.ro/'
                    target="_blank"
                    rel="noreferrer"
                    className='flex flex-col lg:ml-auto md:mr-8 items-center w-fit text-center lg:w-[250px]'
                >
                    <div>
                        <img 
                            src={ici_logo}
                            className='h-[72px]'
                        />
                    </div>
                    <p
                        className='mt-1 font-medium text-[#1e258f]'
                    >
                        INSTITUTUL DE CERCETĂRI INTERDISCIPLINARE
                    </p>
                </a>
                <a
                    href='https://www.uaic.ro/'
                    target="_blank"
                    rel="noreferrer"
                    className='flex flex-col items-center w-fit mt-4 md:mt-0 text-center lg:w-[250px]'
                >
                    <div>
                        <img 
                            src={uaic_logo}
                            className='h-[72px]'
                        />
                    </div>
                    <p
                        className='mt-1 font-medium text-[#1e258f]'
                    >
                        Universitatea "Alexandru Ioan Cuza"
                    </p>
                </a>
            </div>
        </div>
    </div>
  )
}

export default LogoBar